import React from 'react';
import { Box, Title, Space } from '@mantine/core';
import SettingsForm from '../forms/SettingsForm';

const Settings = () => {

	// State and hooks

	return (
		<Box
			className="mainContainer"
			sx={{ position: 'relative', minHeight: '100vh' }}
		>
			{/* Blank */}
			<Space h="md" />
			{/* Title */}
			<Title mb="xl">
				Configuración
			</Title>
			{/* Form */}
			<SettingsForm />
		</Box>
	);

}

export default Settings;
